module.exports = __webpack_public_path__ + "ad2f42dbd6410f2a57046f8632ddc02a.MP3";